module.exports = __webpack_public_path__ + "media/svgs/TAFA20-Webseite_Pfeil-oben_black-5f7c7e8c1ae7d43fbb04db1d76742c7b.svg";